import { Empty, Select, Spin } from 'antd'
import AntdAvatar from 'components/Avatar'
import Pagination from 'components/Pagination'
import {
  EmptyWrapper,
  FlexWrap,
  RowNumberData1,
} from 'components/TableStyles/TableContentStyles/TableContentStyles'
import { StyledTable } from 'components/TableStyles/TableStyles'
import { SubWrapper } from 'modules/Dashboard/Partials/style'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

const StyledSelect = styled(Select)`
  box-shadow: none !important;
  .ant-select-selector {
    position: relative;
    background-color: #fafafb !important;
    border: 0px solid #d9d9d9 !important;
    border-radius: 4px;
    box-shadow: none !important;
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    position: relative;
    background-color: #fafafb !important;
    border: 0px solid #d9d9d9 !important;
    border-radius: 4px;
    box-shadow: none !important;
  }
`
const InterviewerTabel = ({
  interViewerList,
  loading,
  page,
  setPage,
  setSortBy,
}) => {
  const navigate = useNavigate()
  const columns = [
    {
      title: 'Name',
      dataIndex: 'interviewerName',
      width: '60%',
      render: (_, student) => (
        <FlexWrap alignCenter gap="8px">
          <AntdAvatar
            src={student?.userDetails?.profile_picture}
            size={30}
            IconName={student?.userDetails?.first_name
              ?.split('')[0]
              ?.toUpperCase()}
          />
          <RowNumberData1 onClick={() => selectedRow(student)}>
            {`${student?.userDetails?.first_name} ${student?.userDetails?.last_name}`
              .length > 16
              ? `${student?.userDetails?.first_name} ${student?.userDetails?.last_name}`.substr(
                  0,
                  16
                ) + '...'
              : `${student?.userDetails?.first_name} ${student?.userDetails?.last_name}`}
          </RowNumberData1>
        </FlexWrap>
      ),
    },
    {
      title: 'Roles',
      dataIndex: 'jobRoles',
      render: roles => (
        <StyledSelect
          defaultValue={roles?.[0]?.tittle}
          style={{ width: '100%' }}
          onChange={selectedRole => handleSelectChange(selectedRole, roles)}
        >
          {roles.map(role => (
            <Option
              key={role?.id}
              value={role?.id}
              valueParam="id"
              nameParam="tittle"
            >
              {role?.tittle}
            </Option>
          ))}
        </StyledSelect>
      ),
    },
  ]

  const selectedRow = (item, selectedRole) => {
    navigate(`/interviewerDashboard/${item?.interviewerId}`)
  }

  const handleSelectChange = (selectedRole, record) => {}
  const onPageChange = value => {
    setPage(value - 1)
  }
  const onSorting = (pagination, filter, sorter) => {
    setSortBy(sorter)
  }
  return (
    <SubWrapper>
      <StyledTable
        headerColor={true}
        columns={columns}
        pagination={false}
        dataSource={interViewerList?.interviewerRoles}
        loading={loading}
        onChange={onSorting}
        hover={true}
        locale={{
          emptyText: (
            <EmptyWrapper center isSpin={!loading}>
              {loading ? (
                <Spin />
              ) : (
                <Empty description={'No Interviewer Found'} />
              )}
            </EmptyWrapper>
          ),
        }}
      />
      {interViewerList?.totalPages > 1 && (
        <Pagination
          onChange={onPageChange}
          totalPages={interViewerList?.totalPages * 10}
          pageSize={10}
          current={page + 1}
        />
      )}
    </SubWrapper>
  )
}

export default InterviewerTabel
